import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Playground from "@/components/Playground";
import { MaskedLines } from "@/components/motion";

const PlaygroundPage = () => (
  <div data-testid="playground-page" className="bg-background text-foreground min-h-screen">
    <Nav />
    <main className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-32 pb-24">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-telemetry mb-6">
        Sandbox · Mock Telemetry · No API Key Required
      </p>
      <h1 className="font-display font-black tracking-tight text-5xl lg:text-7xl leading-[0.92] mb-6">
        <MaskedLines lines={["Truth Engine", "Playground."]} delay={0.15} />
      </h1>
      <p className="text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed mb-14">
        Pick a scenario — GPS drift, late arrival, off-route behavior, spoofing, or a claim
        mismatch — edit the payload, and watch the engine return truth, compliance flags, anomaly
        tags, and a chained audit signature.
      </p>
      <Playground />
    </main>
    <Footer />
  </div>
);

export default PlaygroundPage;
